import type { ReactNode } from "react";

import { useRoute } from "@softmax/web-features/navigation";

export function FooterSlot({ children }: { children: ReactNode }) {
  const route = useRoute();

  // Game layouts decide their footer using resolved corpus identity.
  if (
    [
      "coworlds",
      "coworldShared",
      "coworldManage",
      "coworldNewRun",
      "coworldRun",
    ].includes(route.name) ||
    route.name.startsWith("game.")
  )
    return null;

  return (
    <div data-site-footer style={{ display: "contents" }}>
      {children}
    </div>
  );
}
